import { createContext } from "react";
const validColumnsComponents = ["div", "span"];
const ColumnsContext = createContext({
  collapseMobile: false,
  collapseTablet: false,
  collapseDesktop: false,
  mobileSpace: "none",
  tabletSpace: "none",
  desktopSpace: "none",
  wideSpace: "none",
  collapsibleAlignmentChildProps: null,
  component: "div"
});
export {
  ColumnsContext,
  validColumnsComponents
};
